import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson44: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[7.63rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson43"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">
            Cancer Defensive Foods
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson45"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[9.63rem] max-w-[125rem] text-gainsboro-100 font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify">
          <p className="m-0">
            A varied diet rich in whole foods may help lower your risk or
            developing cancer and decrease cancer growth. This can include fatty
            fish, vegetables, spices, and fruits like berries.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            What you eat can drastically affect many aspects of your health,
            including your risk of developing chronic diseases like heart
            disease, diabetes and cancer.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            The development of cancer, in particular, has been shown to be
            heavily influenced by your diet.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Many foods contain beneficial compounds that could help decrease the
            growth of cancer.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            There are also several studies showing that a higher intake of
            certain foods could be associated with a lower risk of the disease.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            This article will delve into the research and look at 13 foods that
            may lower your risk of cancer.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>1. Broccoli</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Broccoli contains sulforaphane, a plant compound found in
                cruciferous vegetables that may have potent anticancer
                properties.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                One test-tube study showed that sulforaphane reduced the size
                and number of breast cancer cells by up to 75%.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Similarly, an animal study found that treating mice with
                sulforaphane helped kill off prostate cancer cells and reduced
                tumor volume by more than 50%.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Some studies have also found that a higher intake of cruciferous
                vegetables like broccoli may be linked to a lower risk of
                colorectal cancer.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                One analysis of 35 studies showed that eating more cruciferous
                vegetables was associated with a lower risk of colorectal and
                colon cancer.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Including broccoli with a few meals per week may come with some
                cancer-fighting benefits.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                However, keep in mind that the available research hasn’t looked
                directly at how broccoli may affect cancer in humans.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Instead, it has been limited to test-tube, animal and
                observational studies that either investigated the effects of
                cruciferous vegetables, or the effects of a specific compound in
                broccoli. Thus, more studies are needed.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[42.19rem] object-cover"
          alt=""
          src="/246@2x.png"
        />
        <div className="self-stretch flex flex-row items-center justify-center">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>Summary</b>
            </p>
            <p className="m-0">
              <b>&nbsp;</b>
            </p>
            <p className="m-0">
              Broccoli contains sulforaphane, a compound that has been shown to
              cause tumor cell death and reduce tumor size in test-tube and
              animal studies. A higher intake of cruciferous vegetables may also
              be associated with a lower risk of colorectal cancer.
            </p>
          </div>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>2. Carrots</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Several studies have found that eating more carrots is linked to
                a decreased risk of certain types of cancer.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                For example, an analysis looked at the results of five studies
                and concluded that eating carrots may reduce the risk of stomach
                cancer by up to 26%.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Another study found that a higher intake of carrots was
                associated with 18% lower odds of developing prostate cancer.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                One study analyzed the diets of 1,266 participants with and
                without lung cancer. It found that current smokers who did not
                eat carrots were three times as likely to develop lung cancer,
                compared to those who ate carrots more than once per week.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Try incorporating carrots into your diet as a healthy snack or
                delicious side dish just a few times per week to increase your
                intake and potentially reduce your risk of cancer.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Still, remember that these studies show an association between
                carrot consumption and cancer, but don’t account for other
                factors that may play a role.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[44.81rem] object-cover"
          alt=""
          src="/247@2x.png"
        />
        <div className="self-stretch flex flex-row items-center justify-center">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>Summary</b>
            </p>
            <p className="m-0">
              <b>&nbsp;</b>
            </p>
            <p className="m-0">
              Some studies have found an association between carrot consumption
              and a decreased risk of prostate, lung and stomach cancer.
            </p>
          </div>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center text-[1.5rem] text-white">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Beans</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Beans are high in fiber, which some studies have found may
                  help protect against colorectal cancer.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  One study followed 1,905 people with a history of colorectal
                  tumors, and found that those who consumed more cooked, dried
                  beans tended to have a decreased risk of tumor recurrence.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  An animal study also found that feeding rats black beans or
                  navy beans and then inducing colon cancer blocked the
                  development of cancer cells by up to 75%.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  According to these results, eating a few servings of beans
                  each week may increase your fiber intake and help lower the
                  risk of developing cancer.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  However, the current research is limited to animal studies and
                  studies that show association but not causation. More studies
                  are needed to examine this in humans, specifically.
                </span>
              </span>
            </p>
          </div>
        </div>
        <img
          className="relative w-[96.75rem] h-[44.81rem] object-cover"
          alt=""
          src="/248@2x.png"
        />
        <div className="self-stretch flex flex-row items-center justify-center">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>Summary</b>
            </p>
            <p className="m-0">
              <b>&nbsp;</b>
            </p>
            <p className="m-0">
              Beans are high in fiber, which may be protective against
              colorectal cancer. Human and animal studies have found that a
              higher intake of beans could reduce the risk of colorectal tumors
              and colon cancer.
            </p>
          </div>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center text-[1.88rem] text-white">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>4. Berries</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Berries are high in anthocyanins, plant pigments that have
                  antioxidant properties and may be associated with a reduced
                  risk of cancer.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  In one human study, 25 people with colorectal cancer were
                  treated with bilberry extract for seven days, which was found
                  to reduce the growth of cancer cells by 7%.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Another small study gave freeze-dried black raspberries to
                  patients with oral cancer and showed that it decreased levels
                  of certain markers associated with cancer progression.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  One animal study found that giving rats freeze-dried black
                  raspberries reduced esophageal tumor incidence by up to 54%
                  and decreased the number of tumors by up to 62%.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Similarly, another animal study showed that giving rats a
                  berry extract was found to inhibit several biomarkers of
                  cancer.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Based on these findings, including a serving or two of berries
                  in your diet each day may help inhibit the development of
                  cancer.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Keep in mind that these are animal and observational studies
                  looking at the effects of a concentrated dose of berry
                  extract, and more human research is needed.
                </span>
              </span>
            </p>
          </div>
        </div>
        <img
          className="relative w-[96.75rem] h-[38.75rem] object-cover"
          alt=""
          src="/249@2x.png"
        />
        <div className="self-stretch flex flex-row items-center justify-center">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>Summary</b>
            </p>
            <p className="m-0">
              <b>&nbsp;</b>
            </p>
            <p className="m-0">
              Some test-tube and animal studies have found that the compounds in
              berries may decrease the growth and spread of certain types of
              cancer.
            </p>
          </div>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.5rem] text-white">
          <ul className="m-0 pl-[2.5rem]">
            <li className="mb-[0rem]">
              <b>
                <span>Cinnamon</span>
              </b>
            </li>
          </ul>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Cinnamon is well-known for its health benefits, including its
                ability to reduce blood sugar and ease inflammation.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                In addition, some test-tube and animal studies have found that
                cinnamon may help block the spread of cancer cells.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                A test-tube study found that cinnamon extract was able to
                decrease the spread of cancer cells and induce their death.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Another test-tube study showed that cinnamon essential oil
                suppressed the growth of head and neck cancer cells, and also
                significantly reduced tumor size.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                An animal study also showed that cinnamon extract induced cell
                death in tumor cells, and also decreased how much tumors grew
                and spread.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Including 1/2–1 teaspoon (2–4 grams) of cinnamon in your diet
                per day may be beneficial in cancer prevention, and may come
                with other benefits as well, such as reduced blood sugar and
                decreased inflammation.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                However, more studies are needed to understand how cinnamon may
                affect cancer development in humans.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[37.75rem] object-cover"
          alt=""
          src="/250@2x.png"
        />
        <div className="self-stretch flex flex-row items-center justify-center">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>Summary</b>
            </p>
            <p className="m-0">
              <b>&nbsp;</b>
            </p>
            <p className="m-0">
              Test-tube and animal studies have found that cinnamon extract may
              have anticancer properties and may help decrease the growth and
              spread of tumors. More research in humans is needed.
            </p>
          </div>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.5rem] text-white">
          <ul className="m-0 pl-[2.5rem]">
            <li className="mb-[0rem]">
              <b>
                <span>Nuts</span>
              </b>
            </li>
          </ul>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Research has found that eating nuts may be linked to a lower
                risk of certain types of cancer.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                For instance, a study looked at the diets of 19,386 people and
                found that eating a greater amount of nuts was associated with a
                decreased risk of dying from cancer.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Another study followed 30,708 participants for up to 30 years
                and found that eating nuts regularly was associated with a
                decreased risk of colorectal, pancreatic and endometrial
                cancers.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Other studies have found that specific types of nuts may be
                linked to a lower cancer risk.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                For example, Brazil nuts are high in selenium, which may help
                protect against lung cancer in those with a low selenium status.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Similarly, one animal study showed that feeding mice walnuts
                decreased the growth rate of breast cancer cells by 80% and
                reduced the number of tumors by 60%.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                These results suggest that adding a serving of nuts to your diet
                each day may reduce your risk of developing cancer in the
                future.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Still, more studies in humans are needed to determine whether
                nuts are responsible for this association, or whether other
                factors are involved.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[32.06rem] object-cover"
          alt=""
          src="/251@2x.png"
        />
        <div className="self-stretch flex flex-row items-center justify-center">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>Summary</b>
            </p>
            <p className="m-0">
              <b>&nbsp;</b>
            </p>
            <p className="m-0">
              Some studies have found that an increased intake of nuts may
              decrease the risk of cancer. Research shows that some specific
              types like Brazil nuts and walnuts may also be linked to a lower
              risk of cancer.
            </p>
          </div>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.5rem] text-white">
          <ul className="m-0 pl-[2.5rem]">
            <li className="mb-[0rem]">
              <b>
                <span>Olive Oil</span>
              </b>
            </li>
          </ul>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Olive oil is loaded with health benefits, so it’s no wonder it’s
                one of the staples of the Mediterranean diet.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Several studies have even found that a higher intake of olive
                oil may help protect against cancer.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                One massive review made up of 19 studies showed that people who
                consumed the greatest amount of olive oil had a lower risk of
                developing breast cancer and cancer of the digestive system than
                those with the lowest intake.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Another study looked at the cancer rates in 28 countries around
                the world and found that areas with a higher intake of olive oil
                had decreased rates of colorectal cancer.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Swapping out other oils in your diet for olive oil is a simple
                way to take advantage of its health benefits. You can drizzle it
                over salads and cooked vegetables, or try using it in your
                marinades for meat, fish or poultry.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Though these studies show that there may be an association
                between olive oil intake and cancer, there are likely other
                factors involved as well. More studies are needed to look at the
                direct effects of olive oil on cancer in people.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[47.81rem] object-cover"
          alt=""
          src="/252@2x.png"
        />
        <div className="self-stretch flex flex-row items-center justify-center">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>Summary</b>
            </p>
            <p className="m-0">
              <b>&nbsp;</b>
            </p>
            <p className="m-0">
              Several studies have shown that a higher intake of olive oil may
              be associated with a reduced risk of certain types of cancer.
            </p>
          </div>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>8. Turmeric</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Turmeric is a spice well-known for its health-promoting
                properties. Curcumin, its active ingredient, is a chemical with
                anti-inflammatory, antioxidant and even anticancer effects.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                One study looked at the effects of curcumin on 44 patients with
                lesions in the colon that could have become cancerous. After 30
                days, 4 grams of curcumin daily reduced the number of lesions
                present by 40%.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                In a test-tube study, curcumin was also found to decrease the
                spread of colon cancer cells by targeting a specific enzyme
                related to cancer growth.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Another test-tube study showed that curcumin helped kill off
                head and neck cancer cells.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Curcumin has also been shown to be effective in slowing the
                growth of lung, breast and prostate cancer cells in other
                test-tube studies.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                For the best results, aim for at least 1/2–3 teaspoons (1–3
                grams) of ground turmeric per day. Use it as a ground spice to
                add flavor to foods, and pair it with black pepper to help boost
                its absorption.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[31.06rem] object-cover"
          alt=""
          src="/253@2x.png"
        />
        <div className="self-stretch flex flex-row items-center justify-center">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>Summary</b>
            </p>
            <p className="m-0">
              <b>&nbsp;</b>
            </p>
            <p className="m-0">
              Turmeric contains curcumin, a chemical that has been shown to
              reduce the growth of many types of cancer and lesions in test-tube
              and human studies.
            </p>
          </div>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>9. Citrus Fruits</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Eating citrus fruits such as lemons, limes, grapefruits and
                oranges has been associated with a lower risk of cancer in some
                studies.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                One large study found that participants who ate a higher amount
                of citrus fruits had a lower risk of developing cancers of the
                digestive and upper respiratory tracts.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                A review looking at nine studies also found that a greater
                intake of citrus fruits was linked to a reduced risk of
                pancreatic cancer.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Finally, a review of 14 studies showed that a high intake, or at
                least three servings per week, of citrus fruit reduced the risk
                of stomach cancer by 28%.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                These studies suggest that including a few servings of citrus
                fruits in your diet each week may lower your risk of developing
                certain types of cancer.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Keep in mind that these studies don’t account for other factors
                that may be involved. More studies are needed on how citrus
                fruits specifically affect cancer development.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[37.25rem] object-cover"
          alt=""
          src="/254@2x.png"
        />
        <div className="self-stretch flex flex-row items-center justify-center">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>Summary</b>
            </p>
            <p className="m-0">
              <b>&nbsp;</b>
            </p>
            <p className="m-0">
              Studies have found that a higher intake of citrus fruits could
              decrease the risk of certain types of cancers, including
              pancreatic and stomach cancers, along with cancers of the
              digestive and upper respiratory tracts.
            </p>
          </div>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>10. Flaxseed</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                High in fiber as well as heart-healthy fats, flaxseed can be a
                healthy addition to your diet.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Some research has shown that it may even help decrease cancer
                growth and help kill off cancer cells.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                In one study, 32 women with breast cancer received either a
                flaxseed muffin daily or a placebo for over a month.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                At the end of the study, the flaxseed group had decreased levels
                of specific markers that measure tumor growth, as well as an
                increase in cancer cell death.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                In another study, 161 men with prostate cancer were treated with
                flaxseed, which was found to reduce the growth and spread of
                cancer cells.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Flaxseed is high in fiber, which other studies have found to be
                protective against colorectal cancer.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Try adding one tablespoon (10 grams) of ground flaxseed into
                your diet each day by mixing it into smoothies, sprinkling it
                over cereal and yogurt, or adding it to your favorite baked
                goods.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[38.06rem] object-cover"
          alt=""
          src="/255@2x.png"
        />
        <div className="self-stretch flex flex-row items-center justify-center">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>Summary</b>
            </p>
            <p className="m-0">
              <b>&nbsp;</b>
            </p>
            <p className="m-0">
              Some studies have found that flaxsees may reduce cancer growth in
              breast and prostate cancers. It is also high in fiber, which may
              decrease the risk of colorectal cancer.
            </p>
          </div>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>11. Tomatoes</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Lycopene is a compound found in tomatoes that is responsible for
                its vibrant red color as well as its anticancer properties.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Several studies have found that an increased intake of lycopene
                and tomatoes could lead to a reduced risk of prostate cancer.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                A review of 17 studies also found that a higher intake of raw
                tomatoes, cooked tomatoes and lycopene were all associated with
                a reduced risk of prostate cancer.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Another study of 47,365 people found that a greater intake of
                tomato sauce, in particular, was linked to a lower risk of
                developing prostate cancer.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                To help increase your intake, include a serving or two of
                tomatoes in your diet each day by adding them to sandwiches,
                salads, sauces or pasta dishes.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Still, remember that these studies show there may be an
                association between eating tomatoes and a reduced risk of
                prostate cancer, but they don’t account for other factors that
                could be involved.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[38.31rem] object-cover"
          alt=""
          src="/256@2x.png"
        />
        <div className="self-stretch flex flex-row items-center justify-center">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>Summary</b>
            </p>
            <p className="m-0">
              <b>&nbsp;</b>
            </p>
            <p className="m-0">
              Some studies have found that a higher intake of tomatoes and
              lycopene could reduce the risk of prostate cancer. However, more
              studies are needed.
            </p>
          </div>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>12. Garlic</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                The active component in garlic is allicin, a compound that has
                been shown to kill off cancer cells in multiple test-tube
                studies.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Several studies have found an association between garlic intake
                and a lower risk of certain types of cancer.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                One study of 543,220 participants found that those who ate lots
                of Allium vegetables, such as garlic, onions, leeks and
                shallots, had a lower risk of stomach cancer than those who
                rarely consumed them.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                A study of 471 men showed that a higher intake of garlic was
                associated with a reduced risk of prostate cancer.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Another study found that participants who ate lots of garlic, as
                well as fruit, deep yellow vegetables, dark green vegetables and
                onions, were less likely to develop colorectal tumors. However,
                this study did not isolate the effects of garlic.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Based on these findings, including 2–5 grams (approximately one
                clove) of fresh garlic into your diet per day can help you take
                advantage of its health-promoting properties.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                However, despite the promising results showing an association
                between garlic and a reduced risk of cancer, more studies are
                needed to examine whether other factors play a role.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[41.81rem] object-cover"
          alt=""
          src="/257@2x.png"
        />
        <div className="self-stretch flex flex-row items-center justify-center">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>Summary</b>
            </p>
            <p className="m-0">
              <b>&nbsp;</b>
            </p>
            <p className="m-0">
              Garlic contains allicin, a compound that has been shown to kill
              cancer cells in test-tube studies. Studies have found that eating
              more garlic could lead to decreased risks of stomach, prostate and
              colorectal cancers.
            </p>
          </div>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>13. Fatty Fish</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Some research suggests that including a few servings of fish in
                your diet each week may reduce your risk of cancer.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                One large study showed that a higher intake of fish was
                associated with a lower risk of digestive tract cancer.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Another study that followed 478,040 adults found that eating
                more fish decreased the risk of developing colorectal cancer,
                while red and processed meats actually increased the risk.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                In particular, fatty fish like salmon, mackerel and anchovies
                contain important nutrients such as vitamin D and omega-3 fatty
                acids that have been linked to a lower risk of cancer.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                For example, having adequate levels of vitamin D is believed to
                protect against and reduce the risk of cancer.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                In addition, omega-3 fatty acids are thought to block the
                development of the disease.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Aim for two servings of fatty fish per week to get a hearty dose
                of omega-3 fatty acids and vitamin D, and to maximize the
                potential health benefits of these nutrients.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Still, more research is needed to determine how fatty fish
                consumption may directly influence the risk of cancer in humans.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[41.81rem] object-cover"
          alt=""
          src="/258@2x.png"
        />
        <div className="self-stretch flex flex-row items-center justify-center">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>Summary</b>
            </p>
            <p className="m-0">
              <b>&nbsp;</b>
            </p>
            <p className="m-0">
              Fish consumption may decrease the risk of cancer. Fatty fish
              contains vitamin D and omega-3 fatty acids, two nutrients that are
              believed to protect against cancer.
            </p>
          </div>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>The Bottom Line</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                As new research continues to emerge, it has become increasingly
                clear that your diet can have a major impact on your risk of
                cancer.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Although there are many foods that have potential to reduce the
                spread and growth of cancer cells, current research is limited
                to test-tube, animal and observational studies.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                More studies are needed to understand how these foods may
                directly affect cancer development in humans.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                In the meantime, it’s a safe bet that a diet rich in whole
                foods, paired with a healthy lifestyle, will improve many
                aspects of your health.
              </span>
            </span>
          </p>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson45"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
      </div>
    </div>
  );
};

export default Lesson44;
